import React from 'react'
import { Link } from 'react-router-dom'
import { getProcessSteps, getBookingLink } from './../../content'
import ComplianceDisclaimer from './../../../../components/shared/ComplianceDisclaimer/ComplianceDisclaimer.component'

import './ProcessSteps.component.scss'

const ProcessSteps = ({ subsiteData }) => {
  const steps = getProcessSteps(subsiteData)
  const booking = getBookingLink(subsiteData)

  return (
    <section id='ProcessSteps' className='subsite-section'>
      <div className='subsite-shell'>
        <h2 className='subsite-section-title'>Your Path to Better Coverage</h2>
        <div className='steps-grid'>
          {steps.map(step => (
            <div className='step-card' key={`step-${step.number}`}>
              <div className='step-number'>{step.number}</div>
              <h3>{step.title}</h3>
              <p>{step.body}</p>
            </div>
          ))}
        </div>
        <div className='steps-cta'>
          {booking.external ? (
            <a className='subsite-btn' href={booking.href} target='_blank' rel='noopener noreferrer'>
              Book Your Appointment Now
            </a>
          ) : (
            <Link className='subsite-btn' to={booking.href}>
              Book Your Appointment Now
            </Link>
          )}
        </div>
        <ComplianceDisclaimer variant='short' tone='dark' />
      </div>
    </section>
  )
}

export default ProcessSteps
